import { HANDLE_JOB_CARD_AMC, SET_DEFAULT_JOB_CARD, RESET } from '../actions';
import moment from "moment";

const initialState = {  
    customerName: "",
    phone: [""],
    area: "",
    city: "",
    state: "",
    landmark: "",
    addressType: "",
    pincode: "",
    latitude: 11.3806,
    longitude: 77.8944,
    longitudeDelta: 0.015,
    latitudeDelta: 0.0121,
    addressString: "",
    scrollMap: false,
    fetchLocation: true,
    natureofProblem: "",
    work_type: "",
    servicePerson: "",
    jobCard: [],
    jobcard_number: "",
    edit: false,
    view: false,
    id: "",

    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    field: "14",
    status: [4],
    verificationstatus: 1,
    customerSearchText: "",
    selectedCustomer: null,
    customerData: [],
    filterApplied: true,

    toggleTable: true,
    products: [],

    dateFilter: "Today",
    workTypeFilter: "",
    customer: {}

};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_JOB_CARD_AMC:
      return {
        ...state,
        ...action.data
      };
    case RESET:
        return initialState;
    default:
      return state;
  } 
}
